import React from 'react';

import Utilities from '../utility/Utilities.jsx';

// #region CONTAINER

function ItemContainer(props) {
    let spacer;
    let styleContainer = { verticalAlign: 'top' };
    if (props.blockProps) {
        const borderProps = props.borderProps || {};
        styleContainer = { ...styleContainer, ...borderProps };
        if (props.index != props.count - 1) {
            const style = { ...borderProps };
            if (styleContainer.borderLeftWidth) {
                style.borderLeftColor = styleContainer.borderLeftWidth
            }
            if (props.blockProps.itemSpacing && !Utilities.isNullOrWhitespace(props.blockProps.itemSpacing.value)) {
                style.paddingTop = `${props.blockProps.itemSpacing.value / 2.0}${props.blockProps.itemSpacing.unit}`;
            }
            if (props.blockProps.itemSeparatorSize && !Utilities.isNullOrWhitespace(props.blockProps.itemSeparatorSize.value)) {
                style.borderTopColor = '#e9e9e9';
                style.borderTopStyle = 'solid';
                style.borderTopWidth = `${props.blockProps.itemSeparatorSize.value}${props.blockProps.itemSeparatorSize.unit}`;

                if (!Utilities.isNullOrWhitespace(props.blockProps.itemSeparatorColor)) {
                    style.borderTopColor = props.blockProps.itemSeparatorColor;
                }
            }
            spacer = (
                <>
                    <tr style={props.builder && !props.editor ? { pointerEvents: 'none' } : undefined}><td style={{ ...borderProps, paddingTop: style.paddingTop }}></td></tr>
                    <tr style={props.builder && !props.editor ? { pointerEvents: 'none' } : undefined}><td style={style}></td></tr>
                </>
            )
        }
    }
    let content = (
        <>
            <tr style={props.builder && !props.editor ? { pointerEvents: 'none' } : undefined}>
                <td style={styleContainer}>
                    {props.content}
                    {
                        props.builder &&
                        !props.editor &&
                        (!props.content || props.content.length == 0) &&
                        Utilities.Builder.emptyBlockPlaceholder()
                    }
                </td>
            </tr>
            {spacer}
        </>
    )
    if (!props.builder || props.editor) {
        content = (
            <table
                border="0"
                cellPadding="0"
                cellSpacing="0"
                className="pageBreakInsideAvoid"
                style={{ width: '100%' }}
                width="100%">
                <tbody>
                    {content}
                </tbody>
            </table>
        );
    }
    return content;
}

// #endregion CONTAINER

export default ItemContainer;